import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { StoreContainer, EditStoreContainer, ShowStoreContainer } from '../modules/store';
import EditShippingProfileContainer from '../modules/shipping/containers/editShippingProfileContainer';
import ShippingProfileContainer from '../modules/shipping/containers/shippingProfileContainer';
import { ShippingProfileProvider } from '../modules/shipping/contexts/ShippingProfileContext';
import SalesByProductContainer from '../containers/Reports/salesByProductContainer'
import PaymentSettingsContainer from '../modules/store/containers/paymentSettingsContainer';
import NotificationSettingsContainer from '../modules/store/containers/notificationSettingsContainer';
import AuthSettingsContainer from '../modules/store/containers/authSettingsContainer';

const Stores = ({ match }) => (
  <ShippingProfileProvider>
    <Switch>
      <Route path={`${match.path}/:store_id/shipping-profiles/new`} component={EditShippingProfileContainer} />
      <Route path={`${match.path}/:store_id/shipping-profiles/:id/edit`} component={EditShippingProfileContainer} />
      <Route path={`${match.path}/:store_id/shipping-profiles`} component={ShippingProfileContainer} />
      <Route exact path={`${match.path}`} component={StoreContainer} />
      <Route path={`${match.path}/:id/edit`} component={EditStoreContainer} />
      <Route path={`${match.path}/:storeId/reports/sales-by-product`} component={SalesByProductContainer} />
      <Route path={`${match.path}/:id/payment-settings`} component={PaymentSettingsContainer} />
      <Route path={`${match.path}/:store_id/notification-settings`} component={NotificationSettingsContainer} />
      <Route path={`${match.path}/:id/auth-settings`} component={AuthSettingsContainer} />
      <Route path={`${match.path}/:id`} component={ShowStoreContainer} />
    </Switch>
  </ShippingProfileProvider>
);

Stores.propTypes = {
  match: PropTypes.object,
};

export default Stores;